<template>
	<div class="d-flex flex-column flex h100">
		<div class="navbar theme-login bg box-shadow">
			<div>
				<a href="#/" class="navbar-brand oscar-logo">
					<img :src="brand.logoHeader" alt="." class />
				</a>
			</div>
		</div>
		<div id="content-body">
			<div class="banner"></div>
			<div class="py-2 text-center w-100">
				<div class="mx-auto col-6 w-auto-xs" style="min-width: 320px;">
					<div class="px-6 mt-3">
						<div class="box page-shadow">
							<div class="box-body p-5">
								<template v-if="!error">
									<img
										style="max-width:90%; opacity: 0.7; max-height: 300px;"
										class="logo ng-scope pb-3"
										:src="brand.logo"
									/>
									<form @submit.prevent name="form">
										<div class="form-group">
											<input
												v-model.trim="email"
												type="text"
												class="form-control form-control-lg"
												placeholder="Email"
												required
											/>
										</div>
										<div class="form-group">
											<input
												v-model.trim="password"
												type="password"
												class="form-control form-control-lg"
												placeholder="Password"
												required
											/>
										</div>

										<button @click="login()" type="submit" class="btn btn-block btn-lg theme-login">
											Sign in
										</button>
									</form>
									<div class="mt-4">
										<a href="#/resetpw" class="text-primary _600">Forgot password?</a>
									</div>
					
									<div class="lower-right">
										<a
											href="/static/docs/MZ_Develpment_End_User_License_Agreement_2018.pdf"
											class="text-primary text-xxs _600"
											target="_blank"
										>
											<i class="fas fa-shield-alt mr-1" />EULA
										</a>
										<a
											href="/static/docs/OSCAR_Classroom_Privacy_2.19.19.pdf"
											class="text-primary text-xxs _600 ml-2"
											target="_blank"
										>
											<i class="fas fa-lock-alt mr-1" />Privacy Policy
										</a>
									</div>
								</template>
								<template v-if="error">
									<div class="container d-flex flex-column align-items-center p-3 mt-2">
										<img
											class="security-img"
											style="min-width:200px; max-width:300px; width: 100%"
											src="@/assets/images/security.png"
										/>
										<h4 class="mt-3 px-4 text-center" style="min-width:250px; width: 100%">
											Your login from Clever could not be processed
										</h4>
										<div
											class="row mt-3 justify-content-between"
											style="min-width:200px; max-width:300px; width: 100%"
										>
											<div class="col-12 col-lg-6 form-group">
												<button
													class="btn btn-flat theme-login"
													style="width: 130px"
													@click="hideError"
												>
													Alternate Login
												</button>
											</div>
											<div class="col-12 col-lg-6">
												<a
													class="btn btn-flat btn-danger"
													style="width: 130px"
													href="https://mzscore.zendesk.com/hc/en-us/requests/new"
													>Contact MZD</a
												>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-3 b-t mt-auto theme-login">© 2021 Copyright MZ Development v{{ version }}</div>

		<div class="modal" id="privacyModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header theme-login">
						<h5 class="mb-0">Privacy Policy</h5>
					</div>
					<div class="modal-body padding text-md">
						<p class="_600 theme-login-text text-lg">Google Permissions</p>
						<p>
							Below is a list of Google permissions that we may ask for depending on the functionality
							that you use in OSCAR Classroom. With each scope is the description of what OSCAR Classroom
							is given access to, and why we ask for that.
						</p>
						<p>
							<li>
								<strong>General Google Authentication Scopes</strong> - These are needed for basic
								Google authentication. OSCAR Classroom stores your first name, last name, and email.
								<ul>
									<li><strong>Profile</strong> - View your basic profile info</li>
									<li><strong>Email</strong> - View your email address</li>
									<li><strong>Openid</strong> - Authenticate using OpenID Connect</li>
								</ul>
							</li>
						</p>
						<p>
							<li>
								<strong>Google Drive Scopes</strong> - These scopes give OSCAR Classroom access to your
								files in Google Drive. We use this access to pull student work from Google Drive and
								upload it directly into our system.
								<ul>
									<li><strong>drive.readonly</strong> - View and download your Google Drive files</li>
								</ul>
							</li>
						</p>
					</div>
					<div class="modal-footer">
						<button class="btn btn-primary" data-dismiss="modal">Okay</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AuthService from "@/services/AuthService";
import notie from "@/services/NotieService";
import store from "@/services/Store";
import Router from "@/router";
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();
import pack from "../../../package.json";

export default {
	name: "Login",
	data() {
		return {
			brand: brand,
			email: "",
			password: "",
			version: pack.version,
			redirect: this.$route.query.redirect,

			error: null
		};
	},
	created() {
		AuthService.clearState();
		var url = location.href;
		var host = location.host;
		if (url.indexOf("https") == -1 && url.indexOf("localhost") == -1 && url.indexOf("192.168.") == -1) {
			location.href = "https://" + host;
		}

		if (this.$route.query.error) {
			this.error = this.$route.query.error;
		}
	},

	mounted() {},

	methods: {
		login() {
			var _this = this;
			AuthService.login(this.email, this.password)
				.then(resp => {
					AuthService.getUser()
						.then(resp => {
							this.initStore();
							if (this.redirect) {
								Router.push({
									path: `/${this.redirect}`
								});
							} else {
								Router.push({ path: `/landing` });
							}
						})
						.catch(err => {
							console.log(err);
							notie.error("Failed to initialize user", err);
						});
				})
				.catch(err => {
					console.log(err);
					delete err.suppress;
					notie.error("Failed to log in", err);
				});
		},

		initStore() {},

		hideError() {
			this.$router.replace("/");
			this.displayError = false;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.text-primary:hover {
	text-decoration: underline;
}
.lower-right {
	position: absolute;
	bottom: 0.5rem;
	right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/vues/Login/Login.vue